import {
  Badge,
  Box,
  Container,
  Heading,
  Text,
  VStack,
} from "@chakra-ui/react";
import { SystemShowcaseCarousel } from "./SystemShowcaseCarousel";

export function SystemShowcaseSection() {
  return (
    <Box
      as="section"
      id="conheca"
      py={{ base: 16, md: 20 }}
      bg="barber.400"
      position="relative"
      overflow="hidden"
    >
      <Box
        position="absolute"
        top="50%"
        left="50%"
        transform="translate(-50%, -50%)"
        w={{ base: "120%", md: "70%" }}
        h={{ base: "80%", md: "90%" }}
        bgGradient="radial(circle, rgba(251, 169, 49, 0.14) 0%, rgba(251, 169, 49, 0.04) 42%, transparent 72%)"
        pointerEvents="none"
        aria-hidden
      />

      <Container maxW="container.xl" position="relative" zIndex={1}>
        <VStack spacing={{ base: 8, md: 10 }} textAlign="center">
          <VStack spacing={3} maxW="3xl">
            <Badge
              px={3}
              py={1}
              borderRadius="full"
              bg="blackAlpha.400"
              color="orange.900"
              fontSize="xs"
              letterSpacing="wider"
              textTransform="uppercase"
            >
              Showcase do sistema
            </Badge>

            <Heading
              as="h2"
              size={{ base: "xl", md: "2xl" }}
              color="white"
              lineHeight="shorter"
            >
              Veja o sistema para barbearia por dentro
            </Heading>

            <Text fontSize={{ base: "md", md: "lg" }} color="barber.100">
              Agenda, clientes, serviços e gestão reunidos em uma experiência
              simples e moderna — do celular ou do computador.
            </Text>
          </VStack>

          <SystemShowcaseCarousel />
        </VStack>
      </Container>
    </Box>
  );
}
